import { AuthGuard } from '../guards/auth.guard';
import { isAuthenticatedGuard } from '../guards/isAuthenticatedGuard';
import { DeviceGuard } from './device.guard';

export const guards = {
  AuthGuard,
  isAuthenticatedGuard,
  DeviceGuard
}